import styled from 'styled-components';
import {HOME_PAGE} from '../../../../themes/css-global-classes';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './swiper-wrapper.default.box';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const PcBox = styled(BasePcBox)`
    .${HOME_PAGE} & {
        width: 100%;
    }
`;

const MobileBox = styled(BaseMobileBox)`
    padding-left: 6px;
`;

export const SwiperWrapperMrGreenBox = styledByDevice(PcBox, MobileBox);